import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FilterRequestEvaluated } from '../shared/filter-request-evaluated.model';
import { Role } from '../../requets/shared/model/Role.model';
import { BossDependence } from '../../requets/shared/model/boss-dependence.model';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { UtilityService } from 'src/app/core/shared/utility.service';
import { ConfirmationDialogComponent } from 'src/app/core/modal/confirmation-dialog/confirmation-dialog.component';
import { SelectCollageDialogComponent } from 'src/app/core/modal/select-collage-dialog/select-collage-dialog.component';
import { College } from '../../requets/shared/model/college.model';
import { FilterRequestRecon } from '../shared/filter-request-recon.model';
import { RequestService } from '../../requets/shared/request.service';

@Component({
  selector: 'app-search-fields-requests',
  templateUrl: './search-fields-requests.component.html',
  styleUrls: ['./search-fields-requests.component.scss']
})
export class SearchFieldsRequestsComponent implements OnInit {

  fechaInicial: Date;
  fechaFinal: Date;
  selectedCollage: String;
  selectedType: String = 'MATERIA REGULAR';
  materia: String;
  programa: String;


  enabledSpinner = false;
  enabledType = false;
  enabledMateriaRegular = true;
  enabledPifle = true;
  filterRequest: FilterRequestRecon;
  messageError: String = '';
  claseMessage: String = 'messaje-error';

  colleges: College[];

  @Output()
  sendSearchRequest: EventEmitter<any> = new EventEmitter();
  @Input() roles: Role[] = [];
  @Input() typeValidation: number;
  @Input() bossDeependence: BossDependence;
  @Input() currentRol: Role;

  constructor(private requestService: RequestService,
              private dialog: MatDialog,
              private utilityService: UtilityService) { }

  ngOnInit() {
    this.getColleges();
  }

  sendSearchParam() {
    if (this.fechaInicial !== undefined && this.fechaInicial !== null ) {
      if (this.fechaFinal !== undefined && this.fechaFinal !== null ) {
        if (this.selectedType !== undefined && this.selectedType !== '' ) {
          this.filterRequest = new FilterRequestRecon();
          this.filterRequest.fechaInicial = !this.fechaInicial ? null : this.fechaInicial;
          this.filterRequest.fechaFinal = !this.fechaFinal ? null : this.fechaFinal;
          this.filterRequest.institucion = !this.selectedCollage ? null : this.selectedCollage;
          this.filterRequest.materia = !this.materia ? null : this.materia;
          this.filterRequest.programa = !this.programa ? null : this.programa;
          this.filterRequest.tipo = !this.selectedType ? null : this.selectedType;
          this.messageError = '';
          this.sendSearchRequest.emit(this.filterRequest);
        } else {
          this.messageError = 'Seleccionar el tipo de solcitud';
        }
      } else {
        this.messageError = 'Seleccionar la fecha final';
      }
    } else {
      this.messageError = 'Seleccionar la fecha inicial';
    }
  }

  openDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data =  { collages: this.colleges};
    dialogConfig.width = '70%';
    const dialogRef = this.dialog.open(SelectCollageDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(value => {
        if (value !== null) {
          this.selectedCollage = value.college.codigo;
        }
    });
  }

  private getColleges() {
    this.requestService.getColleges().subscribe(
      (result) => {
        if (result.data !== []) {
          this.colleges = result.data  as College[];
          this.setDataAsistete();
        }
      }
    );
  }

  clean() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      tittle: 'Mensaje Confirmación',
      message:
        '¿Esta seguro que desea limpiar los filtros?'
    };
    dialogConfig.width = '30%';
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, dialogConfig );
    dialogRef.afterClosed().subscribe(value => {
      if (value === 1) {
        this.filterRequest = new FilterRequestRecon();
        this.fechaInicial = null;
        this.fechaFinal = null;
        this.selectedCollage = '';
        this.selectedType = '';
        this.materia = '';
        this.programa = '';
      }
    });
  }

  private setDataAsistete() {
    if (this.typeValidation > 0) {
        this.enabledType = true;
          if (this.currentRol.rol === this.utilityService.rolCoordinador) {
            this.enabledPifle = true;
            this.enabledMateriaRegular = false;
            this.selectedType = 'MATERIA LENGUA EXTRANGERA';
          }

          if (this.currentRol.rol === this.utilityService.rolVicedecano) {
            this.enabledMateriaRegular = true;
            this.enabledPifle = false;
            this.selectedType = 'MATERIA REGULAR';
          }

          if (this.currentRol.rol === this.utilityService.rolJefeDepto) {
            this.enabledMateriaRegular = true;
            this.enabledPifle = false;
            this.selectedType = 'MATERIA REGULAR';
          }
    } else {
      // renviar de que el usuario no tiene un rol valido
    }
  }
}
